import { Button, GridRow, Message, ModalDialog } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { useStore } from "csi/state/hooks";
import BOMCompareBanner from "src/Specification/BOM/BOMCompareBanner";
import ApparelBOMPageStore from "./ApparelBOMPageStore";

const ApparelBOMBanners: FunctionComponent = observer(() => {
	return (
		<>
			<BOMUpdatesBanner />
			<BOMCompareBanner />
		</>
	);
});

const BOMUpdatesBanner: FunctionComponent = observer(() => {
	const { pageStore } = useStore();
	const store = pageStore as ApparelBOMPageStore;
	const { showViewUpdatesDialog, onViewUpdates, setPartMaterialTab } = store;

	useEffect(() => {
		setPartMaterialTab(showViewUpdatesDialog);
	  }, [showViewUpdatesDialog]);

	return (
		<>
			{showViewUpdatesDialog && (
				<ModalDialog
					disableEscapeKeyDown
					open={showViewUpdatesDialog}
					titleRes="NewUpdatesAvailable"
				>
					{{
						buttons: (
							<GridRow justifyContent="flex-end" spacing={2}>
								<Button
									design="primary"
									onClick={onViewUpdates}
									res="ViewUpdates"
								/>
							</GridRow>
						),
						main: (
							<Message
								sx={{
									backgroundColor: "transparent",
								}}
								titleRes="ViewUpdatesDialogMsg"
								variant="info"
							/>
						),
					}}
				</ModalDialog>
			)}
		</>
	);
});

export default ApparelBOMBanners;
